/**
 *
 *
 * @author Dylan Doldersum
 * @date 14/01/2025
 * @param {*} message
 * @param {string} [type='success']
 */

function showToast(message, type = 'success') {
    const toastContainer = document.getElementById('toast-container');

    let icon;
    switch (type) {
        case 'success':
            icon = '✅';
            break;
        case 'error':
            icon = 'ℹ️';
            break;
        case 'warning':
            icon = 'ℹ️';
            break;
        default:
            icon = 'ℹ️';
    }

    const toast = document.createElement('div');
    toast.className = `toast ${type}`;
    toast.innerHTML = `
        <span class="toast-icon">${icon}</span>
        <span>${message}</span>
    `;

    toastContainer.appendChild(toast);

    toast.addEventListener('animationend', (event) => {
        if (event.animationName === 'fadeOut') {
            toast.remove();
        }
    });

    setTimeout(() => {
        if (toast.parentElement) {
            toast.remove();
        }
    }, 4000);
}
